import { api } from "../utils/api";
import type {
  DBStoreCopyJob,
  RestStartStoreCopy,
} from "@KassaroAB/shared/types/storeCopyJob";
import type { StoreCopyJobId, StoreId } from "@KassaroAB/shared/types/ids";

export const getStoreCopyJobsApi = (
  targetStoreId: StoreId,
): Promise<DBStoreCopyJob[]> => {
  return api.get(`admin/stores/${targetStoreId}/copyJobs`);
};

export const startStoreCopyJobApi = (
  targetStoreId: StoreId,
  body: RestStartStoreCopy,
): Promise<DBStoreCopyJob> => {
  return api.post(`admin/stores/${targetStoreId}/copyJobs`, body);
};

export const retryStoreCopyJobApi = (
  targetStoreId: StoreId,
  storeCopyJobId: StoreCopyJobId,
): Promise<DBStoreCopyJob> => {
  return api.post(
    `admin/stores/${targetStoreId}/copyJobs/${storeCopyJobId}/retry`,
    {},
  );
};
